import React from 'react';
import { PropTypes } from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { SingleViewLink } from '@payer-admin-ui/components-v2/src/links/SingleViewLink';
import { CountryFlag } from '../IndicatorIcon/CountryFlag';
import { AmountFormat } from '../Format/AmountFormat';
import { SessionsStatusChips } from './SessionsStatusChips';

const CustomerRow = ({
  customer: { id, regNumber, merchantId, companyName, countryCode, credit, sessionAlerts },
  customersRouteInfo,
  merchantsRouteInfo,
}) => {
  return (
    <TableRow>
      <TableCell>
        <SingleViewLink keys={{ customerId: id }} singlePageRoute={customersRouteInfo}>
          {companyName}
        </SingleViewLink>
      </TableCell>
      {merchantsRouteInfo && (
        <TableCell>
          <SingleViewLink keys={{ id: merchantId }} singlePageRoute={merchantsRouteInfo} />
        </TableCell>
      )}
      <TableCell>{regNumber}</TableCell>
      <TableCell>
        <span style={{ whiteSpace: 'nowrap' }}>
          <SessionsStatusChips sessionAlerts={sessionAlerts} />
        </span>
      </TableCell>
      <TableCell>
        <CountryFlag countryCode={countryCode} />
      </TableCell>
      <TableCell>
        {credit && credit.creditLimitAmount && (
          <div style={{ height: '2em' }}>
            <AmountFormat amount={credit.creditLimitAmount} currencyCode={credit.currencyCode} fractionDigits="0" />
          </div>
        )}
      </TableCell>
    </TableRow>
  );
};

CustomerRow.propTypes = {
  customer: PropTypes.shape({
    id: PropTypes.string,
    merchantId: PropTypes.string,
    regNumber: PropTypes.string,
    companyName: PropTypes.string,
    countryCode: PropTypes.string,
    credit: PropTypes.shape({
      currencyCode: PropTypes.string,
      used: PropTypes.number,
      allowed: PropTypes.number,
      creditLimitAmount: PropTypes.number,
    }),
    sessionAlerts: SessionsStatusChips.propTypes.sessionAlerts,
  }),
  merchantsRouteInfo: PropTypes.object,
  customersRouteInfo: PropTypes.object.isRequired,
};

export default CustomerRow;
